/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import ThemeIconProvider from './ThemeIconProvider';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) System Email Icon component.
 */
export const SystemEmailIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <ThemeIconProvider name='SystemEmailIcon' {...props} legacyIcon={(
      <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none'>
        <path d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z"
          stroke={iconColor}
          strokeWidth="1.5"/>
        <path d="M22 6L12.2867 12.7993C12.1146 12.9198 11.8854 12.9198 11.7133 12.7993L2 6"
          stroke={iconColor}
          strokeWidth="1.5"/>
      </svg>
    )} />
  );
};
